export function formatCnDate(iso: string): string {
  const [, m, d] = iso.split('-');
  return `${Number(m)}月${Number(d)}日`;
}

export function formatCnRange(start: string, end: string): string {
  const [sy, sm, sd] = start.split('-');
  const [, em, ed] = end.split('-');
  if (sm === em) {
    return `${sy}年${Number(sm)}月${Number(sd)}日 – ${Number(em)}月${Number(ed)}日`;
  }
  return `${sy}年${Number(sm)}月${Number(sd)}日 – ${Number(em)}月${Number(ed)}日`;
}

export function toLocalDate(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d, 23, 59, 59);
}

export function daysUntil(iso: string): number {
  const now = new Date();
  const target = toLocalDate(iso);
  const diff = target.getTime() - now.getTime();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

export function pad2(n: number): string {
  return n.toString().padStart(2, '0');
}